import { useState, useEffect, useRef } from "react";
import { EDITOR_UI } from "./config/editorConstants";

export const useSelectionButton = (menuPinned: boolean, wrapRef: React.RefObject<HTMLDivElement>) => {
  const [showButton, setShowButton] = useState(false);
  const [buttonPosition, setButtonPosition] = useState<{ top: number; left: number } | null>(null);
  const delayRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const PAD = EDITOR_UI.PAD;
  const BTN_BOX = EDITOR_UI.BTN_BOX;

  const placeButtonsNearSelection = () => {
    if (menuPinned) return;
    const wrapEl = wrapRef.current;
    const sel = window.getSelection();
    if (!wrapEl || !sel || sel.rangeCount === 0 || !sel.toString()) {
      setShowButton(false);
      return;
    }

    const range = sel.getRangeAt(0);
    const rect = range.getClientRects().length ? range.getClientRects()[0] : range.getBoundingClientRect();
    const wrapRect = wrapEl.getBoundingClientRect();

    let top = rect.top - wrapRect.top - 10;
    let left = rect.right - wrapRect.left + PAD;
    top += wrapEl.scrollTop || 0;
    left += wrapEl.scrollLeft || 0;
    top = Math.max(PAD, Math.min(top, wrapEl.clientHeight - BTN_BOX));
    left = Math.max(PAD, Math.min(left, wrapEl.clientWidth - BTN_BOX));

    if (delayRef.current) clearTimeout(delayRef.current);
    delayRef.current = setTimeout(() => setButtonPosition({ top, left }), 60);
    setShowButton(true);
  };

  useEffect(() => {
    const onSelectionChange = () => {
      if (menuPinned) return;
      const sel = window.getSelection();
      if (!sel || !sel.toString()) {
        setShowButton(false);
        return;
      }
      placeButtonsNearSelection();
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => document.removeEventListener("selectionchange", onSelectionChange);
  }, [menuPinned]);

  return { showButton, buttonPosition, placeButtonsNearSelection };
};
